<template>
  <div class="container pap-formx">
    <!-- <div v-if="showForm" class="card"> -->
    <div class="card">
      <FormTitle :title="data.formTitle" :iconclass="titleIconClass" />
      <!-- <h5 class="form-header card-header bg-primary text-white">
        <div class="icon-wrapper"><i :class="titleIconClass"></i></div>
        <div>{{ data.formTitle }}</div>
      </h5> -->
      <!-- <h5 class="card-header bg-primary text-white">
        <i :class="titleIconClass"></i>{{ data.formTitle }}
      </h5> -->
      <div class="card-body">
        <b-form novalidate @submit.prevent="submit">
          <slot name="topText"></slot>
          <b-form-group
            v-for="field in data.orderedFields"
            :key="field"
            :id="field + '-group'"
            :label="data.fields[field].label"
            :label-for="field"
            label-class="label-bold"
            :invalid-feedback="data.fields[field].errorMsg"
            :state="data.fields[field].valid"
          >
            <b-form-input
              v-if="
                data.fields[field].type === undefined ||
                data.fields[field].type === 'text'
              "
              :id="field"
              :key="field"
              :maxlength="data.fields[field].maxLength"
              :placeholder="data.fields[field].placeholder"
              v-model="data.fields[field].value"
              @input="fieldOnInput(field)"
              :state="data.fields[field].valid"
              trim
            ></b-form-input>

            <PasswordFieldInput
              v-if="data.fields[field].type === 'password'"
              :id="field"
              :key="field"
              :maxlength="data.fields[field].maxLength"
              :placeholder="data.fields[field].placeholder"
              :label="data.fields[field].label"
              :state="data.fields[field].valid"
              :errorMsg="data.fields[field].errorMsg"
              @password-value-input="setField($event, field)"
            />
          </b-form-group>

          <FormErrorAlert
            :showAlert="showFormActionError"
            :msg="formErrorAlertMsg"
          />

          <button
            @click="setSubmitted"
            type="submit"
            class="btn btn-block btn-submit pap-form__btn"
          >
            {{ data.submitButtonText }}
          </button>
        </b-form>
      </div>
    </div>
  </div>
  <!-- <b-form-group
            id="lName-group"
            label=""
            label-for="lName"
            label-class="label-bold"
          >
            <p class="text-secondary text-smaller-1">Hey there fucker</p>
          </b-form-group> -->
</template>

<script>
import FormTitle from '@/components/form/FormTitle';
import PasswordFieldInput from '@/components/form/FormPasswordFieldInput';

import FormErrorAlert from '@/components/form/FormErrorAlert.vue';

export default {
  name: 'Form',
  components: {
    FormTitle,
    PasswordFieldInput,
    FormErrorAlert,
  },
  props: ['data', 'fieldValues', 'formErrorMsg'],
  data: function () {
    return {
      dataObj: null,

      // Text of any overall form error, e.g. validation error, submission result error, etc.
      //formErrorMsg: '',

      // Form validation: true: Every field has a valid value; false: At least one field has an invalid value
      formValid: false,

      // Form submission result: Result of form submission (when validated).
      // true: Result of submitted form action was an error; false: Initial state - no error (since form
      // not submitted yet); methods can "reset" this to false to simulate initial state any time after a
      // form submission.
      // formError: false,

      // Flag: true: Form submit button was clicked; false: Reset to primitive state, i.e. form not submitted
      formSubmitted: false,

      showFormActionError: false,
      formErrorAlertMsg: '',

      externalFormErrorMsg: '',
    };
  },
  computed: {
    titleIconClass: function () {
      var classObj = {};
      classObj[this.data.headerIconClass] = true;
      return classObj;
    },
    // showFormActionError: function () {
    //   var formErrorMsgExists = this.formErrorMsg !== '' ? true : false;
    //   return (this.formSubmitted && !this.formValid) || formErrorMsgExists;
    // },
    defaultFormErrorMsg: function () {
      return `Ooops! Please correct the error(s) shown in the form above, then click ${this.data.submitButtonText} again.`;
    },
    // theFormErrorMsg: function () {
    //   return this.formErrorMsg !== ''
    //     ? this.formErrorMsg
    //     : this.defaultFormErrorMsg;
    //   // return this.formErrorMsg || this.defaultFormErrorMsg;
    // },

    // externalFormErrorMsg: function () {
    //   return this.formErrorMsg; // formErrorMsg is a prop
    // },
  },
  methods: {
    setSubmitted: function () {
      this.formSubmitted = true;
    },
    resetSubmitted: function () {
      this.formSubmitted = false;
    },

    // For given field fieldName, on input to the field, i.e. when the value changes, reset the
    // form state to its primitive/original state in terms of form error alerts, form field error alerts, etc.
    fieldOnInput: function (fieldName) {
      this.resetSubmitted(); // Reset 'form submitted' flag to false, i.e. "starting over" as tho form was never submitted.
      this.showFormActionError = false;
      if (this.data.fields[fieldName].valid === false) {
        this.data.fields[fieldName].valid = null; // Set to null to not show validation state feedback on the field, i.e. NO red/green styles
      }
    },

    setField: function (fieldValue, fieldName) {
      this.data.fields[fieldName].value = fieldValue;
      this.fieldOnInput(fieldName);
    },

    validate: function () {
      // If no model defined (i.e. creating form with just a submit button, e.g. delete user account)
      if (this.data.model === undefined) {
        this.dataObj = {};
        this.formValid = true;
        return;
      }
      var formData = {}; // user's entered form data
      Object.keys(this.data.fields).forEach((fieldName) => {
        formData[fieldName] = this.data.fields[fieldName].value;
      });

      var dataObj = this.data.model.update(formData); // Validation here so, test if validation passed next...

      //   console.log('data', dataObj);
      this.formValid = this.data.model.validationPassed();

      // Reset form field values to display latest 'state' of form after validation/sanitization/etc.
      Object.keys(dataObj).forEach((fieldName) => {
        this.data.fields[fieldName].value = dataObj[fieldName].trim();
      });

      if (!this.formValid) {
        this.data.model.validationErrors().forEach((err) => {
          var propName = this.data.model.getErrorProp(err);
          // console.log('prop', propName);
          this.data.fields[propName].valid = false; // Set to false to show validation state feedback of 'invalid', i.e. red styles
          this.data.fields[propName].errorMsg = this.data.model.getErrorMsg(
            err
          );
          // console.log(propName, Message.getErrorMsg(err));
        });
      }
      this.dataObj = dataObj;
    },

    submit: function () {
      // Validate form data
      this.validate();

      // Reset to blank EACH time submit is called; otherwise, if 'external' error string is still present (meaning THIS
      // externalFormErrorMsg property HAS a non-empty value), on subsequent submit, if there's no "new" external
      // error message that comes in (and the form data was obviously valid), the "else" block (form IS valid) below runs,
      // and the 'externalFormErrorMsg' is found to still be non-empty,
      // so the shorFormActionError gets set to true, so user will see the error alert even though there's no error, i.e. it's
      // "left over" from previous submission. So... clean up the 'state'!!
      this.externalFormErrorMsg = '';

      // Emit the results of the validation
      // If the form data passsed validation, emit the data obj containing the form data;
      // otherwise, emit null.
      var emitThis = this.dataObj;
      if (!this.formValid) {
        this.showFormActionError = true;
        this.formErrorAlertMsg = this.defaultFormErrorMsg;
        emitThis = null;
      } else {
        // Form comp rerendered with not-empty error msg string passed in (prop)
        if (this.externalFormErrorMsg !== '') {
          this.showFormActionError = true;
          this.formErrorAlertMsg = this.externalFormErrorMsg;
        }
      }
      this.$emit('form-validated', emitThis);
      //   console.log('Data is VALID -- move on nah...');
    },
  },

  created: function () {
    // console.log('CREATED', this.externalFormErrorMsg);

    this.externalFormErrorMsg = this.formErrorMsg;

    // If not null, fieldValues is simple object of initial value for each field: fieldName: value
    if (this.fieldValues) {
      Object.keys(this.fieldValues).forEach((fieldName) => {
        this.data.fields[fieldName].value = this.fieldValues[fieldName];
      });
      this.dataObj = this.fieldValues;
    }
    if (
      this.externalFormErrorMsg !== undefined &&
      this.externalFormErrorMsg !== ''
    ) {
      this.showFormActionError = true;
      this.formErrorAlertMsg = this.externalFormErrorMsg;
    }
  },
};
</script>

<style>
/* .icon-wrapper {
  background-color: green;
  max-width: 10%;
} */
/* .icon-wrapper {
  max-height: 100%;
} */

/* repeat(auto-fit, minmax(2rem, 300px)) */
/* .form-headerXXX {
  display: grid;
  gap: 2px;
  grid-template-columns: 1fr 11fr;  
} */
/* .form-header {
  display: flex;
  flex-direction: row;
  align-items: center;
} */

/* .form-header > div {
  border: 1px solid white;
} */
</style>